module.exports = __webpack_public_path__ + "static/img/detail_img_3.c5508caa.png";